import { render, staticRenderFns } from "./HospClinDoctor2.vue?vue&type=template&id=7b131702"
import script from "./HospClinDoctor2.vue?vue&type=script&lang=js"
export * from "./HospClinDoctor2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports